var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      ref: "contentScroll",
      staticClass: "chat-frame-container",
      style: { "margin-bottom": !_vm.getIsAIEnd() ? "20px" : "0" },
    },
    [
      _c(
        "div",
        {
          class: {
            "sidebar-loading": !_vm.isFullScreen(),
            "full-screen-loading": _vm.isFullScreen(),
          },
        },
        [
          _c("div", {
            directives: [
              {
                name: "loading",
                rawName: "v-loading",
                value: _vm.loading,
                expression: "loading",
              },
            ],
            attrs: { "element-loading-spinner": "el-icon-loading" },
          }),
        ]
      ),
      _vm._l(_vm.getChatMessageList, function (item, index) {
        return [
          _vm.custom && item.isNewChat
            ? _c("div", { key: index, staticClass: "clear-history" }, [
                _c(
                  "span",
                  {
                    on: {
                      click: function ($event) {
                        return _vm.$emit("clearHistory")
                      },
                    },
                  },
                  [_vm._v("清除历史对话")]
                ),
              ])
            : _vm._e(),
          _vm.isFullScreen() && item.type === "G"
            ? _c(
                "el-divider",
                {
                  key: index,
                  staticClass: "divider-full",
                  attrs: { "content-position": "center" },
                  on: { mousedown: _vm.allowTextSelection },
                },
                [_vm._v(" " + _vm._s(item.text) + " ")]
              )
            : _vm._e(),
          !_vm.isFullScreen() && item.type === "G"
            ? _c(
                "el-divider",
                {
                  key: index,
                  staticClass: "divider",
                  attrs: { "content-position": "center" },
                  on: { mousedown: _vm.allowTextSelection },
                },
                [_vm._v(" " + _vm._s(item.text) + " ")]
              )
            : _vm._e(),
          item.type === "welcome"
            ? _c("ChatWelcome", {
                key: index,
                staticClass: "chat-welcome",
                on: { mousedown: _vm.allowTextSelection },
              })
            : _vm._e(),
          item.type === "ai"
            ? _c("ChatMessageAi", {
                key: index,
                attrs: {
                  data: item,
                  text: item.text,
                  "message-id": item.conversation_id || item.id,
                  "has-new-list": item.hasNewList ? item.hasNewList : false,
                  "thinking-txt": item.thinkingTxt,
                  "news-name": item.news ? item.news.newsName : "",
                  "news-list": item.news ? item.news.newsList : [],
                  type: item.type,
                  "img-error": item.imgError,
                  "is-skip": item.tmpInfo ? item.tmpInfo.isMust == 2 : false,
                  "tmp-is-ok": item.tmpIsOk,
                  "is-collect": item.isCollect,
                  "is-history": item.isHistory,
                  "is-like": item.isLike,
                  "is-no-like": item.isNoLike,
                  source: item.source,
                  "video-load-text": item.videoLoadText,
                  index: index,
                  "is-send-selected-topic": item.isSendSelectedTopic,
                  "is-hotspot": item.isHotspot,
                },
                on: {
                  createTopic: _vm.createTopic,
                  openRevision: _vm.openRevision,
                  resetAnswer: function ($event) {
                    return _vm.resetAnswer(index)
                  },
                  collectSearch: _vm.collectSearch,
                },
              })
            : _vm._e(),
          item.type === "user" && !item.hide
            ? _c("ChatMessageUser", {
                key: index,
                attrs: {
                  index: index,
                  text: item.text,
                  "message-type": item.messageType,
                  "file-extension": item.fileExtension,
                  "file-name": item.fileName,
                  "file-size": item.fileSize,
                  "file-image-url": item.fileImageUrl,
                  "file-url": item.fileUrl,
                  format: item.format,
                  "is-sensitive": item.isSensitive,
                  "is-sensitive-reply": item.isSensitiveReply,
                },
                on: {
                  editSensitive: _vm.editSensitive,
                  addTemp: function ($event) {
                    return _vm.$emit("addTemp", item.text)
                  },
                },
              })
            : _vm._e(),
        ]
      }),
      _vm.isBacktop
        ? _c(
            "div",
            { staticClass: "backtop", on: { click: _vm.backtop } },
            [
              !_vm.backTopLoading
                ? [
                    _c("img", {
                      staticClass: "img-icon",
                      staticStyle: { width: "17px", height: "17px" },
                      attrs: {
                        src: require("@/assets/image/aigc/go-bottom.png"),
                        alt: "",
                      },
                    }),
                    _c("img", {
                      staticClass: "img-icon-select",
                      staticStyle: { width: "17px", height: "17px" },
                      attrs: {
                        src: require("@/assets/image/aigc/go-bottom-select.png"),
                        alt: "",
                      },
                    }),
                  ]
                : _c("div", { staticClass: "loading-spinner" }),
            ],
            2
          )
        : _vm._e(),
      !_vm.getIsAIEnd() &&
      (!_vm.isFullScreen() ||
        _vm.getIsShowDouyinBZhangGuide ||
        _vm.getIsShowImageGeneration)
        ? _c("div", { staticStyle: { height: "64px", width: "100%" } })
        : _vm._e(),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }